import { HorizontalBar } from 'vue-chartjs'
import DefaultOptions from '../DefaultOptions'

export default HorizontalBar.extend({
  props: ['data', 'options'],

  data () {
    return {
      defaultOptions: {

      }
    }
  },

  mounted () {
    let options = Object.assign({}, DefaultOptions, this.defaultOptions, this.options)
    this.renderChart(this.data, options)
  }
})



// WEBPACK FOOTER //
// ./src/components/vuestic-components/vuestic-chart/chart-types/HorizontalBarChart.js